<div id="payee-cases-container" class="flex column">
  <div id="case-table-filters">
    <payee-case-reference-id-filter></payee-case-reference-id-filter>
    <payee-case-debtor-name-filter></payee-case-debtor-name-filter>
    <payee-case-stage-filter [stages]="stages"></payee-case-stage-filter>
    <payee-case-started-at-filter></payee-case-started-at-filter>
    <ng-container
      *ngFor="let component of additionalFilters"
      [ngComponentOutlet]="component"
    ></ng-container>
  </div>
  <ng-container *ngIf="showInfo">
    <payee-info *ngIf="draftSelected" class="state-info">
      {{ "CASES_TABLE.TABLE_INFO.DRAFT_INFO" | translate }}
    </payee-info>
    <payee-info *ngIf="ongoingSelected" class="state-info">
      {{ "CASES_TABLE.TABLE_INFO.ONGOING_INFO" | translate }}
    </payee-info>
    <payee-info *ngIf="closedSelected" class="state-info">
      {{ "CASES_TABLE.TABLE_INFO.CLOSED_INFO" | translate }}
    </payee-info>
  </ng-container>

  <ng-container *ngIf="!loading.value && dataSource.data.length > 0">
    <payee-cases-table
      [dataSource]="dataSource"
      [additionalColumns]="additionalColumns"
      [additionalActions]="additionalActions"
      [allowDelete]="allowDelete"
      [allowEdit]="allowEdit"
    >
    </payee-cases-table>

    <mat-paginator
      class="mat-elevation-z1"
      [length]="pagination?.total"
      [pageIndex]="pagination?.currentPage - 1"
      [pageSize]="pagination?.perPage"
      [pageSizeOptions]="[5, 10, 25]"
      (page)="pageChange($event)"
      showFirstLastButtons
    ></mat-paginator
  ></ng-container>

  <h1
    *ngIf="!loading.value && dataSource.data.length === 0"
    id="no-case-found-text"
  >
    {{ "CASES_TABLE.NO_CASES.TITLE" | translate }}
  </h1>

  <mat-progress-spinner
    *ngIf="loading.value"
    id="cases-loading-spinner"
    mode="indeterminate"
    diameter="100"
  ></mat-progress-spinner>
</div>
